const $modal = $('#movie-Stage');
const $content = $('#movie-Iframe');

// preload
import {preload} from "../include/module";
preload();

// // resizing
// import {resizing} from "../include/module";
// resizing();

// //ページ内リンクのアニメーション
// import {anchorScroll} from "../include/module";
// anchorScroll();

// //ページTOP
// import {backToTop} from "../include/module";
// backToTop();


$(window).on('load' , function() {

  showMovie();
  showImg();
  pageTop();
  anchorLink();
  scrollAnime();

});

// ------------------------------------------------------------------------
// showMovie
// ----- BOTH
// ------------------------------------------------------------------------
const showMovie = () => {

  // open
  $('.js-Youtube').on('click', function(){

    const dataID = $(this).attr('data-youtube');

    $('#movie-Stage').css({'opacity':'0','display':'block'}).stop().animate({'opacity':'1','width':100+'%','height':100+'%','top':0,'left':0},300,'easeOutQuart',function(){

      //iframe append
      $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/'+dataID+'?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>');
      // fadeIn
      $modal.stop().fadeIn(400);
      return false;

  	});
  });

  //close
  $('#movie-Close,#movie-Iframe').on('click', function(){

    $('#movie-Stage').css({'opacity':'1'}).stop().animate({'opacity':'0'},300,'easeOutQuart',function(){
      $('#movie-Stage').css({'display':'none'});
      $content.children().remove();
		});
    //
    // $modal.stop().fadeOut(300, function(){
    //   $content.children('iframe').remove();
    // });
  });

};

// ------------------------------------------------------------------------
// showImg
// ----- BOTH
// ------------------------------------------------------------------------
const showImg = () => {

  // open
  $('.js-Img').on('click', function(){

    const dataID = $(this).attr('data-img');

    $('#movie-Stage').css({'opacity':'0','display':'block'}).stop().animate({'opacity':'1','width':100+'%','height':100+'%','top':0,'left':0},300,'easeOutQuart',function(){


      //img append
      $content.append('<img src="'+dataID+'">');
      // fadeIn
      $modal.stop().fadeIn(400);
      return false;

  	});
  });

  //close
};


// ------------------------------------------------------------------------
// pageTop
// ----- BOTH
// ------------------------------------------------------------------------
const pageTop = () => {

  $("#st-Footer_pagetop").on("click", function(){
    var linkSpeed    = 700;
    $("html, body").animate({scrollTop: 0}, linkSpeed, "easeInOutQuint");
    return false;
  });
};

// ------------------------------------------------------------------------
// anchorLink
// ----- BOTH
// ------------------------------------------------------------------------
const anchorLink = () => {
  //ページ外からのページ内リンク
  var urlHash = location.hash;
  if(urlHash) {
      $('body,html').stop().scrollTop(0);
      setTimeout(function(){
          var target = $(urlHash);
          var position = target.offset().top - 0;
          $('body,html').stop().animate({scrollTop:position}, 500);
      }, 200);
  }

  //ページ内リンク
  $("a[href^='#']").on("click", function(){
    var linkSpeed    = 700;
    var linkHref     = $(this).attr("href");
    var linkTarget   = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
    var linkAdjust   = 0;
    var linkPosition = linkTarget.offset().top;
    $("html, body").animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, "easeInOutQuint");
    return false;
  });
};

// ------------------------------------------------------------------------
// scrollAnime
// ----- BOTH
// ------------------------------------------------------------------------
const scrollAnime = () => {

  const controller = new ScrollMagic.Controller();
  const targets = document.querySelectorAll(".js-scrollAnimation");
  const targetsArray = Array.prototype.slice.call(targets); //Array
  targetsArray.forEach(target => {
  //シーンを作成
  const scene = new ScrollMagic.Scene({
      triggerElement: target,
      triggerHook: .9
    })
    .setClassToggle(target, "is-animated")
    .addTo(controller);
  });

};


// WEBPACK FOOTER //
// ./src/assets/js/index/script.js